module.exports = __webpack_public_path__ + "static/img/logo1.030886fd.png";